import { Pipe, PipeTransform, Input } from '@angular/core';
import { empty } from 'rxjs/Observer';

@Pipe({
  name: 'array'
})
export class ArrayPipe implements PipeTransform {

  transform(value: any, emptyText: string, selector: any): any {
    if(value == null || value.length === 0)
      return emptyText;
    
    //value = value.map(x => JSON.stringify(x));

    if(!selector)
      return value.join(", ");

    return value.map(selector).join(", ");
  }
}
